/* All-Star theme behaviour. No framework; each part checks for its own markup. */
(function () {
  var config = window.allStar || {};
  var routes = config.routes || {};

  /* ---------- Toast ---------- */

  var toastTimer;
  function toast(message) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Money ---------- */

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = config.moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/<[^>]*>/g, '');
  }

  /* ---------- Header that reappears on scroll-up ---------- */

  // The announcement bar stays pinned at the top; the floating header slides in under it.
  function measureAnnouncement() {
    var bar = document.querySelector('.as-announcement');
    var height = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--as-announcement-h', height + 'px');
  }

  function initFloatingHeader() {
    var floating = document.querySelector('[data-floating-header]');
    if (!floating) return;
    measureAnnouncement();
    window.addEventListener('resize', measureAnnouncement, { passive: true });
    var last = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y < 80) floating.classList.remove('is-visible');
      else if (y < last - 5) floating.classList.add('is-visible');
      else if (y > last + 5) floating.classList.remove('is-visible');
      floating.setAttribute('aria-hidden', floating.classList.contains('is-visible') ? 'false' : 'true');
      last = y;
    }, { passive: true });
  }

  /* ---------- Smooth scroll buttons ---------- */

  function initScrollButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-scroll-to]');
      if (!button) return;
      var target = document.getElementById(button.getAttribute('data-scroll-to'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ---------- Cart ---------- */

  function cartJson() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function renderCart(cart) {
    var drawer = document.querySelector('[data-cart-drawer]');
    updateCount(cart.item_count);
    if (!drawer) return;
    var list = drawer.querySelector('[data-cart-items]');
    var empty = drawer.querySelector('[data-cart-empty]');
    var footer = drawer.querySelector('[data-cart-footer]');
    var summary = drawer.querySelector('[data-cart-summary]');
    summary.textContent = cart.item_count === 0
      ? 'Your cart is empty'
      : cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
    empty.hidden = cart.item_count > 0;
    footer.hidden = cart.item_count === 0;
    list.innerHTML = '';
    cart.items.forEach(function (item, index) {
      var line = index + 1;
      var options = (item.options_with_values || [])
        .filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return o.value; })
        .join(' · ');
      var li = document.createElement('li');
      li.className = 'as-cart__item';
      li.innerHTML =
        '<div class="as-cart__thumb">' + (item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="64" height="64" loading="lazy">' : '') + '</div>' +
        '<div class="as-cart__info">' +
          '<p class="as-cart__name"></p>' +
          '<p class="as-cart__options"></p>' +
          '<p class="as-cart__price">' + money(item.final_line_price) + '</p>' +
        '</div>' +
        '<div class="as-cart__controls">' +
          '<button type="button" class="as-cart__remove" data-line="' + line + '" data-qty="0" aria-label="Remove">' + icons.trash + '</button>' +
          '<div class="as-cart__qty">' +
            '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="One fewer">' + icons.minus + '</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="One more">' + icons.plus + '</button>' +
          '</div>' +
        '</div>';
      li.querySelector('.as-cart__name').textContent = item.product_title;
      li.querySelector('.as-cart__options').textContent = options;
      list.appendChild(li);
    });
    var savings = cart.total_discount || 0;
    var savingsRow = drawer.querySelector('[data-cart-savings]');
    savingsRow.hidden = savings <= 0;
    drawer.querySelector('[data-cart-savings-amount]').textContent = '−' + money(savings);
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
  }

  var icons = {
    trash: '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>',
    minus: '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>'
  };

  function openCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) { window.location.href = routes.cart || '/cart'; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('as-locked');
    cartJson().then(renderCart).catch(function () {});
  }

  function closeCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('as-locked');
  }

  function changeLine(line, quantity) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.classList.add('is-busy');
    return fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  // Adds one or more variants. items: [{ id, quantity }]. discount: optional code.
  function addToCart(items, discount) {
    return fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () {
        var attribution = window.asAttribution ? window.asAttribution.syncCart() : Promise.resolve();
        return attribution.then(function () {
          if (!discount) return;
          return fetch((routes.cartUpdate || '/cart/update') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: discount })
          });
        });
      })
      .then(cartJson)
      .then(function (cart) {
        renderCart(cart);
        toast('Added to cart');
        return cart;
      });
  }

  function initCart() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-open]')) { event.preventDefault(); openCart(); return; }
      if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeCart(); return; }
      var lineButton = event.target.closest('[data-cart-items] [data-line]');
      if (lineButton) {
        changeLine(Number(lineButton.getAttribute('data-line')), Number(lineButton.getAttribute('data-qty')));
        return;
      }
      if (event.target.closest('[data-cart-checkout]')) {
        event.preventDefault();
        var button = event.target.closest('[data-cart-checkout]');
        button.disabled = true;
        var attribution = window.asAttribution ? window.asAttribution.syncCart() : Promise.resolve();
        attribution.finally(function () { window.location.href = '/checkout'; });
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCart();
    });
  }

  /* ---------- Klaviyo signup: email, then optional phone ---------- */

  function formatPhone(phone) {
    var digits = phone.replace(/\D/g, '');
    if (digits.charAt(0) === '1' && digits.length === 11) return '+' + digits;
    if (digits.length === 10) return '+1' + digits;
    if (phone.charAt(0) === '+') return phone;
    return '+' + digits;
  }

  function subscribe(email, phone) {
    var k = config.klaviyo || {};
    var subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var attributes = { email: email, subscriptions: subscriptions };
    if (phone) {
      attributes.phone_number = formatPhone(phone);
      subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(k.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-01-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: k.source || 'Website Early Access',
            profile: { data: { type: 'profile', attributes: attributes } }
          },
          relationships: { list: { data: { type: 'list', id: k.listId } } }
        }
      })
    }).then(function (r) { if (!r.ok) throw new Error('Signup failed'); });
  }

  function initSignup() {
    document.querySelectorAll('[data-signup]').forEach(function (root) {
      var step1 = root.querySelector('[data-signup-step="1"]');
      var step2 = root.querySelector('[data-signup-step="2"]');
      var emailInput = step1.querySelector('input[type="email"]');
      var phoneInput = step2.querySelector('input[type="tel"]');
      var emailEcho = step2.querySelector('[data-signup-email]');
      var success = root.getAttribute('data-success') || "You're on the list.";

      function reset() {
        emailInput.value = '';
        phoneInput.value = '';
        step2.hidden = true;
        step1.hidden = false;
        root.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
      }

      function send(withPhone) {
        root.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
        subscribe(emailInput.value.trim(), withPhone ? phoneInput.value.trim() : '')
          .then(function () { toast(success); })
          .catch(function () { toast('Something went wrong. Please try again.'); })
          .finally(reset);
      }

      step1.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!emailInput.value.trim()) { toast('Please enter your email.'); return; }
        emailEcho.textContent = emailInput.value.trim();
        step1.hidden = true;
        step2.hidden = false;
        phoneInput.focus();
      });
      step2.addEventListener('submit', function (event) { event.preventDefault(); send(true); });
      root.querySelector('[data-signup-skip]').addEventListener('click', function () { send(false); });
    });
  }

  window.asTheme = { addToCart: addToCart, openCart: openCart, toast: toast, money: money };

  initFloatingHeader();
  initScrollButtons();
  initCart();
  initSignup();
})();
